// extracted by mini-css-extract-plugin
module.exports = {"icon":"payment-profile_icon__3VeSF","activeIcon":"payment-profile_activeIcon__2wRp3","title":"payment-profile_title__n67uM"};